// NOTICE: KAPTION-INTEGRATION
// team-location.HIDDEN.1 — reactive, fail-closed availability of team location
// for the current account (see helper/kaptionTeamLocationAvailability.js).
import { computed } from 'vue';
import { useAccount } from './useAccount';
import {
  isTeamLocationEnabledForAccount,
  canViewTeamLocationMap,
} from 'dashboard/helper/kaptionTeamLocationAvailability';

export function useKaptionTeamLocationAvailability() {
  const { currentAccount } = useAccount();

  const isTeamLocationEnabled = computed(() =>
    isTeamLocationEnabledForAccount(currentAccount.value)
  );
  const canViewTeamLocation = computed(() =>
    canViewTeamLocationMap(currentAccount.value)
  );

  return { isTeamLocationEnabled, canViewTeamLocation };
}
